import { cryptoCurrencies } from '@/config/constants';

export const getFormattedCurrency = (currency: string) => {
  const isCurrencyToUpperCase = currency.length > 1 && !cryptoCurrencies.includes(currency);
  return isCurrencyToUpperCase ? currency.toUpperCase() : currency;
};
